import React, { useState, useEffect } from "react";
import "react-dropdown/style.css";
import "./editError.scss";
import Modal from "../modal/modal";
import ApiHandler from "../api";

const EditAvailabilityComponent = ({
  availability,
  availabilitySaved,
  closeEditAvailability,
}) => {
  // Get project from localStorage
  const [project, setProject] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const apiHandler = new ApiHandler();

  useEffect(() => {
    const projectFromStorage = localStorage.getItem("project");
    if (projectFromStorage) {
      setProject(JSON.parse(projectFromStorage));
    }
  }, []);

  // Initialize state
  const initializeMaxInactiveForReason = () => {
    let maxInactiveForReason = 0;
    if (availability.totalNotCleanedRobots > 0)
      maxInactiveForReason += availability.totalNotCleanedRobots;

    if (availability.totalRobotsNotFinishedCleaning > 0)
      maxInactiveForReason += availability.totalRobotsNotFinishedCleaning;

    return maxInactiveForReason;
  };

  const [state, setState] = useState({
    ...availability,
    maxInactiveForReason: initializeMaxInactiveForReason(),
    dontCalculateAvailability: availability.dontCalculateAvailability || false,
  });

  const onChange = (event, param) => {
    const { value } = event.target;
    let newState = {};

    if (event.target.type === "text") newState[param] = value;
    else {
      if (value.length) newState[param] = Math.floor(value);
      else newState[param] = undefined;
    }

    setState((prevState) => ({ ...prevState, ...newState }));
  };

  const onCheckboxChange = (event, param) => {
    const { checked } = event.target;
    setState((prevState) => ({ ...prevState, [param]: checked }));
  };

  const onSubmit = async () => {
    if (state.totalInactiveForReason > state.maxInactiveForReason) {
      alert(
        "Number of robots inactive for a reason cannot be greater than " +
          state.maxInactiveForReason
      );
      return;
    }

    if (state.totalInactiveForReason < 0) {
      alert("Number of robots inactive for a reason cannot be negative");
      return;
    }

    if (state.totalInactiveForReason > state.maxInactiveForReason) {
      alert(
        "Total number of inactive robots cannot be greater than " +
          state.maxInactiveForReason
      );
      return;
    }

    try {
      setIsLoading(true);
      let params = { ...state, robotLists: undefined };
      params.projectId = project?._id;

      await apiHandler.editAvailability(params, availability._id);
      closeEditAvailability();
      availabilitySaved();
    } catch (error) {
      console.error("Error editing availability:", error);
      alert("Error saving availability. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      title={`Robot Availability: ${availability.date}`}
      onClose={closeEditAvailability}
    >
      <div className="input-line">
        <div className="input-description">
          Number of robots inactive for a reason
        </div>
        <input
          value={state.totalInactiveForReason}
          placeholder=""
          type="number"
          max={state.totalNotCleanedRobots}
          onChange={(e) => onChange(e, "totalInactiveForReason")}
        />
      </div>

      <div className="input-line">
        <div className="input-description">Reason for inactive robots</div>
        <input
          value={state.inactiveReason}
          placeholder=""
          type="text"
          onChange={(e) => onChange(e, "inactiveReason")}
        />
      </div>

      <div className="input-line checkbox">
        <input
          type="checkbox"
          checked={state.dontCalculateAvailability}
          onChange={(e) => onCheckboxChange(e, "dontCalculateAvailability")}
        />
        <div className="input-description">Don't calculate availability</div>
      </div>

      <div className="buttons-wrapper">
        <div className="button cancel" onClick={closeEditAvailability}>
          CANCEL
        </div>
        <div
          className={`button ${isLoading ? "loading" : ""}`}
          onClick={onSubmit}
        >
          {isLoading ? "SAVING..." : "SAVE"}
        </div>
      </div>
    </Modal>
  );
};

export default EditAvailabilityComponent;
